const R = require('ramda')

const installData = require('./data/installClient')

module.exports = R.pipe(
  installData,
)
